import React from 'react';
import { CONNECTION_BUTTON_TYPES } from './constants';
import { ConnectButton } from './style';
import { useTranslation } from 'react-i18next';

interface ConnectionButtonProps {
  type: CONNECTION_BUTTON_TYPES;
  handleClick: () => void;
}

export const ConnectionButton = ({
  type,
  handleClick,
}: ConnectionButtonProps) => {
  const { t } = useTranslation();
  switch (type) {
    case CONNECTION_BUTTON_TYPES.RECONNECT:
      return (
        <ConnectButton
          onClick={handleClick}
          bgColor='#EEEFF2'
          fontColor='#272A32'
        >
          {t('Reconnect')}
        </ConnectButton>
      );
    case CONNECTION_BUTTON_TYPES.DISCONNECT:
      return (
        <ConnectButton
          onClick={handleClick}
          bgColor='#FEF6F5'
          fontColor='#E84C3D'
        >
          {t('Disconnect')}
        </ConnectButton>
      );
    default:
      return null;
  }
};
